"use strict";
const options_collection = {
  rangeSlider: ".price-range .range-slider",
  rangeSliderMin: ".range-slider-min",
  rangeSliderMax: ".range-slider-max",
  minPriceRange: ".min-price-range",
  maxPriceRange: ".max-price-range",
  collectionFilterBlocks: ".filter-blocks",
  productgridcontainer: "#productgridcontainer",
  collectionFiltersForm: "#CollectionFiltersForm",
  section: ".sec__collection-main",
  paginationNumbers: ".shop-pagination--numbers",
};

const collectionFilterDrawer = {
  id: "CollectionSidebar",
  isReady() {
    return Boolean(window.themeDrawer && window.themeDrawer.drawers && window.themeDrawer.drawers[this.id]);
  },
  isOpen() {
    return this.isReady() && window.themeDrawer.isOpen(this.id);
  },
  toggle() {
    if (!this.isReady()) return false;
    window.themeDrawer.toggle(this.id);
    return true;
  },
  close() {
    if (!this.isReady()) return false;
    window.themeDrawer.close(this.id);
    return true;
  },
  syncTriggers(isOpen) {
    document.querySelectorAll(".btn-filter.drawer").forEach((trigger) => {
      trigger.classList.toggle("open", isOpen);
      trigger.setAttribute("aria-expanded", String(isOpen));
    });
  },
};

const filterKeyboardBound = new WeakSet();
function enableFilterKeyboardButton(element) {
  if (filterKeyboardBound.has(element)) return;
  filterKeyboardBound.add(element);
  element.setAttribute("role", "button");
  const disabled = element.classList.contains("option-disabled") || Boolean(element.closest("li.disabled"));
  element.tabIndex = disabled ? -1 : 0;
  if (disabled) element.setAttribute("aria-disabled", "true");
  element.addEventListener("keydown", (event) => {
    if (event.target !== element || (event.key !== "Enter" && event.key !== " ")) return;
    event.preventDefault();
    if (element.getAttribute("aria-disabled") !== "true") element.click();
  });
}

class BtnFilter extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onOpen.bind(this), false);
  }
  connectedCallback() {
    enableFilterKeyboardButton(this);
    this.setAttribute("aria-controls", collectionFilterDrawer.id);
    this.setAttribute("aria-expanded", String(collectionFilterDrawer.isOpen()));
  }
  onOpen() {
    if (collectionFilterDrawer.toggle()) {
      collectionFilterDrawer.syncTriggers(collectionFilterDrawer.isOpen());
      return;
    }
  }
}
customElements.define("btn-filter", BtnFilter);

class CloseFilter extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onClose.bind(this), false);
  }
  connectedCallback() {
    enableFilterKeyboardButton(this);
  }
  onClose() {
    if (collectionFilterDrawer.close()) {
      collectionFilterDrawer.syncTriggers(false);
      return;
    }
  }
}
customElements.define("close-filter", CloseFilter);

class FacetApplyCanvas extends CloseFilter {}
customElements.define("facet-apply-canvas", FacetApplyCanvas);

class FilterItem extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.filterItem.bind(this), false);
  }
  connectedCallback() {
    enableFilterKeyboardButton(this);
  }
  filterItem() {
    if (this.getAttribute("aria-disabled") === "true") return;
    const url = this.getAttribute("data-href");
    eventCollectionShopify.renderSectionFilter(url);
  }
}
customElements.define("filter-item", FilterItem);

class FacetClearAll extends CloseFilter {
  constructor() {
    super();
    this.addEventListener("click", this.filterItem.bind(this), false);
  }
  filterItem() {
    if (this.getAttribute("aria-disabled") === "true") return;
    const url = this.getAttribute("data-href");
    eventCollectionShopify.renderSectionFilter(url);
  }
}
customElements.define("facet-clear-all", FacetClearAll);

var eventCollectionShopify = (function () {
  return {
    init: function () {
      this.bindSortFocusModality();
      this.bindSortSelect();
      this.bindPageNumberPagination();
      this.bindHistoryNavigation();
      this.updateSortSelectLabels();
      this.ionRangeSlider();
      this.initCollectionPromoGrid();
    },

    bindSortFocusModality: function () {
      if (this.sortFocusModalityBound) return;

      const clearKeyboardFocus = () => {
        document.documentElement.classList.remove("collection-keyboard-focus");
      };

      document.addEventListener("keydown", (event) => {
        if (event.key !== "Tab") return;
        document.documentElement.classList.add("collection-keyboard-focus");
      });
      document.addEventListener("pointerdown", clearKeyboardFocus);
      document.addEventListener("touchstart", clearKeyboardFocus, { passive: true });
      this.sortFocusModalityBound = true;
    },

    bindSortSelect: function () {
      if (this.sortSelectBound) return;
      document.addEventListener("change", (event) => {
        const target = event.target;
        if (!target?.matches?.(".collection-sort-select")) return;
        this.updateSortSelectLabels(document, target.value);
        this.applySort(target.value);
      });
      this.sortSelectBound = true;
    },

    bindPageNumberPagination: function () {
      if (this.pageNumberPaginationBound) return;
      document.addEventListener("click", (event) => {
        const target = event.target.closest(`${options_collection.paginationNumbers} a[href]`);
        if (!target || !target.closest(options_collection.section)) return;
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          (target.target && target.target !== "_self")
        ) {
          return;
        }

        event.preventDefault();
        this.applyPageNumber(target.href);
      });
      this.pageNumberPaginationBound = true;
    },

    updateSortSelectLabels: function (context = document, selectedValue = null) {
      context.querySelectorAll(".collection-sort-select").forEach((select) => {
        if (selectedValue !== null) select.value = selectedValue;
        const selectedOption = select.options[select.selectedIndex];
        select.closest(".collection-sort-select-wrap")?.setAttribute(
          "data-selected-label",
          selectedOption ? selectedOption.textContent.trim() : ""
        );
      });
    },

    bindHistoryNavigation: function () {
      if (this.historyNavigationBound) return;
      window.addEventListener("popstate", () => {
        if (!document.querySelector(options_collection.section)) return;
        const searchParams = window.location.search.slice(1);
        this.renderSectionFilter(this.renderUrl(searchParams), searchParams, null, {
          skipHistory: true,
        });
      });
      this.historyNavigationBound = true;
    },

    applySort: function (value) {
      this.updateSortSelectLabels(document, value);
      let queryString = window.location.search;
      queryString = this.removeParam("sort_by", queryString);
      queryString = this.removeParam("page", queryString);
      const searchParams = queryString.replace("?", "") + "&sort_by=" + value;
      const url = this.renderUrl(searchParams);
      this.renderSectionFilter(url, searchParams);
    },

    applyPageNumber: function (href) {
      const section = document.querySelector(options_collection.section);
      const sectionId = section?.dataset.sectionId;
      if (!sectionId) {
        window.location.href = href;
        return;
      }

      const cleanUrl = new URL(href, window.location.origin);
      cleanUrl.searchParams.delete("section_id");
      const searchParams = cleanUrl.searchParams.toString();
      const renderUrl = `${cleanUrl.pathname}?section_id=${sectionId}${searchParams ? `&${searchParams}` : ""}`;
      const historyUrl = `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`;

      this.renderSectionFilter(renderUrl, searchParams, historyUrl, {
        scrollToProductGrid: true,
      });
    },

    scrollToProductGridTop: function () {
      const productGridContainer = document.querySelector(options_collection.productgridcontainer);
      if (!productGridContainer) return;

      const rootStyles = getComputedStyle(document.documentElement);
      const cssLengthToPx = (value) => {
        const length = value.trim();
        if (!length) return 0;
        if (length.endsWith("rem")) {
          return parseFloat(length) * parseFloat(rootStyles.fontSize);
        }
        return parseFloat(length) || 0;
      };
      const stickyHeaderOffset = Array.from(
        document.querySelectorAll(".section-site-header, .shopify-section-header-sticky, .section-header")
      ).reduce((offset, header) => {
        const rect = header.getBoundingClientRect();
        const style = getComputedStyle(header);
        if (
          rect.height <= 0 ||
          rect.bottom <= 0 ||
          rect.top > 1 ||
          !["fixed", "sticky"].includes(style.position)
        ) {
          return offset;
        }

        return Math.max(offset, rect.bottom);
      }, 0);
      const headerHeight = Math.max(
        stickyHeaderOffset,
        cssLengthToPx(rootStyles.getPropertyValue("--height-header"))
      );
      const scrollOffset = cssLengthToPx(rootStyles.getPropertyValue("--ds-space-4"));
      requestAnimationFrame(() => {
        const targetTop = productGridContainer.getBoundingClientRect().top + window.pageYOffset - headerHeight - scrollOffset;

        window.scrollTo({
          top: Math.max(targetTop, 0),
          behavior: "smooth",
        });
      });
    },

    initCollectionPromoGrid: function (context = document) {
      const scope = context instanceof Element ? context : document;
      scope.querySelectorAll("[data-collection-promo-grid]").forEach((root) => {
        if (root.dataset.initialized === "true") return;

        const slot = root.querySelector("[data-promo-slot]");
        const candidates = Array.from(
          root.querySelectorAll("template[data-promo-candidate]")
        );

        if (!slot || candidates.length === 0) return;

        root.dataset.initialized = "true";
        const selected = candidates[Math.floor(Math.random() * candidates.length)];
        slot.replaceChildren(selected.content.cloneNode(true));
      });
    },

    ionRangeSlider: function () {
      const price_range = document.querySelector(".price-range");
      const maxRange = document.querySelector(
        options_collection.rangeSliderMax
      );
      const minRange = document.querySelector(
        options_collection.rangeSliderMin
      );
      const minPrice = document.querySelector(".min-price-range");
      const maxPrice = document.querySelector(".max-price-range");
      var minPriceRange = 0;
      var maxPriceRange = 0;
      if (!price_range) return;
      document
        .querySelector(options_collection.minPriceRange)
        .addEventListener(
          "change",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            target.value = target.value.replace(',','')
            if (Number(minRange.min) + Number(target.value) >= 0) {
              if (Number(target.value) > Number(maxRange.max)) {
                minPrice.value = Number(maxRange.max);
              } else {
                minPrice.value = Number(target.value);
              }
            } else {
              minPrice.value = Number(minRange.min);
            }
            const formData = new FormData(
              document.querySelector(options_collection.collectionFiltersForm)
            );
            const params = new URLSearchParams(formData).toString();
            const nameMin = minPrice.getAttribute("name");
            const nameMax = maxPrice.getAttribute("name");
            var queryString = window.location.search;
            queryString = this.removeParam(nameMin, queryString);
            queryString = this.removeParam(nameMax, queryString);
            var searchParams = queryString.replace("?", "") + "&" + params;
            const url = this.renderUrl(searchParams);
            this.renderSectionFilter(url, searchParams);
          },
          false
        );
      document
        .querySelector(options_collection.maxPriceRange)
        .addEventListener(
          "change",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            target.value = target.value.replace(',','')
            if (Number(maxRange.max) - Number(target.value) >= 0) {
              maxPrice.value = Number(target.value);
            } else {
              maxPrice.value = Number(maxRange.max);
            }
            const formData = new FormData(
              document.querySelector(options_collection.collectionFiltersForm)
            );
            const params = new URLSearchParams(formData).toString();
            const nameMin = minPrice.getAttribute("name");
            const nameMax = maxPrice.getAttribute("name");
            var queryString = window.location.search;
            queryString = this.removeParam(nameMin, queryString);
            queryString = this.removeParam(nameMax, queryString);
            var searchParams = queryString.replace("?", "") + "&" + params;
            const url = this.renderUrl(searchParams);
            this.renderSectionFilter(url, searchParams);
          },
          false
        );
      document
        .querySelector(options_collection.rangeSliderMin)
        .addEventListener(
          "input",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (Number(maxRange.value) - Number(target.value) >= 1) {
              minPrice.value = Number(target.value);
              minPriceRange = Number(target.value) * 100;
            } else {
              target.value = Number(maxRange.value) - 1;
              minPrice.value = Number(target.value);
              minPriceRange = (Number(maxRange.value) - 1) * 100;
            }
            const price_format = Shopify.formatMoney(
              minPriceRange,
              cartStrings.money_format
            );
            document.querySelector(".price-lable .min").innerHTML =
              price_format;
            target
              .closest(".price-range")
              .style.setProperty(
                "--range-from",
                (minRange.value / Number(target.getAttribute("max"))) * 100 +
                  "%"
              );
          },
          false
        );
      document
        .querySelector(options_collection.rangeSliderMax)
        .addEventListener(
          "input",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (target.value - minRange.value >= 1) {
              maxPrice.value = target.value;
              maxPriceRange = Number(target.value) * 100;
            } else {
              target.value = Number(minRange.value) + Number(1);
              maxPrice.value = target.value;
              maxPriceRange = (Number(minRange.value) + Number(1)) * 100;
            }
            const price_format = Shopify.formatMoney(
              maxPriceRange,
              cartStrings.money_format
            );
            document.querySelector(".price-lable .max").innerHTML =
              price_format;
            target
              .closest(".price-range")
              .style.setProperty(
                "--range-to",
                (maxRange.value / Number(target.getAttribute("max"))) * 100 +
                  "%"
              );
          },
          false
        );
      document
        .querySelectorAll(options_collection.rangeSlider)
        .forEach((sliderRange) => {
          sliderRange.addEventListener(
            "change",
            (event) => {
              event.preventDefault();
              const target = event.currentTarget;
              const formData = new FormData(
                document.querySelector(options_collection.collectionFiltersForm)
              );
              const params = new URLSearchParams(formData).toString();
              const nameMin = minPrice.getAttribute("name");
              const nameMax = maxPrice.getAttribute("name");
              var queryString = window.location.search;
              queryString = this.removeParam(nameMin, queryString);
              queryString = this.removeParam(nameMax, queryString);
              var searchParams = queryString.replace("?", "") + "&" + params;
              const url = this.renderUrl(searchParams);
              this.renderSectionFilter(url, searchParams);
            },
            false
          );
        });
    },

    removeParam: function (key, sourceURL) {
      var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString =
          sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
      if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
      }
      return rtn;
    },

    renderUrl: function (searchParams) {
      const sectionId = document.querySelector(options_collection.section)
        .dataset.sectionId;
      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
      return url;
    },

    getOpenFilterGroupLabels: function () {
      return Array.from(
        document.querySelectorAll(
          `${options_collection.collectionFilterBlocks} .collection-filter__group.active[data-filter-label]`
        )
      ).map((group) => group.dataset.filterLabel);
    },

    restoreOpenFilterGroups: function (labels = []) {
      const openLabels = new Set(labels);
      if (!openLabels.size) return;

      document
        .querySelectorAll(
          `${options_collection.collectionFilterBlocks} .collection-filter__group[data-filter-label]`
        )
        .forEach((group) => {
          if (!openLabels.has(group.dataset.filterLabel)) {
            group.classList.remove("active");
            group.querySelector(".collection-filter__content")?.style.removeProperty("display");
            return;
          }

          group.classList.add("active");
          group.querySelector(".collection-filter__content")?.style.removeProperty("display");
        });
    },

    renderSectionFilter: function (url, searchParams, historyUrl = null, options = {}) {
      // Filtering replaces the result set; an earlier search batch must not append to it.
      const searchLoadMore = document.querySelector('[data-search-loadmore]');
      searchLoadMore?.cancelSearchLoad?.();
      if (searchLoadMore) searchLoadMore.filterPending = true;
      this.sectionRequest?.abort();
      const request = this.sectionRequest = new AbortController();
      const openFilterGroupLabels = this.getOpenFilterGroupLabels();
      this.toggleLoading(document.body, true);
      return fetch(`${url}`, { signal: request.signal })
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }
          return response.text();
        })
        .then((responseText) => {
          // A superseded response must never replace the latest selected page.
          if (request.signal.aborted || this.sectionRequest !== request) return;
          const parsed = new DOMParser().parseFromString(responseText, "text/html");
          const nextGrid = parsed.querySelector(options_collection.productgridcontainer);
          if (!nextGrid) throw new Error("Missing product grid in section response");
          // Retain styles supplied by Section Rendering before extracting the grid.
          parsed.querySelectorAll("style[data-section-stylesheet]").forEach((style) => {
            if (!nextGrid.contains(style)) nextGrid.prepend(style);
          });
          const collectionFilterBlocks = parsed.querySelector(options_collection.collectionFilterBlocks);
          const currentFilterBlocks = document.querySelector(
            options_collection.collectionFilterBlocks
          );
          if (collectionFilterBlocks && currentFilterBlocks) {
            currentFilterBlocks.innerHTML = collectionFilterBlocks.innerHTML;
          }
          this.restoreOpenFilterGroups(openFilterGroupLabels);
          const productGrid = document.querySelector(options_collection.productgridcontainer);
          productGrid.innerHTML = nextGrid.innerHTML;
          window.productItemVideoReveal?.init(productGrid);
          this.updateSortSelectLabels(document);
          if (collectionFilterDrawer.isOpen()) {
            document.querySelector(".btn-filter")?.classList.add("open");
          }
          if (!options.skipHistory) this.updateUrl(url, searchParams, historyUrl);
          if (options.scrollToProductGrid) {
            this.scrollToProductGridTop();
          }
          this.initCollectionPromoGrid();
          this.ionRangeSlider();
        })
        .catch((error) => {
          if (request.signal.aborted || this.sectionRequest !== request) return;
          console.error("Unable to update product results", error);
          if (options.skipHistory) {
            // The browser has already moved to this URL; render it normally if AJAX fails.
            window.location.reload();
            return;
          }
          // Keep the last rendered page and its URL consistent on failure.
          const currentSort = new URL(window.location.href).searchParams.get("sort_by") || "";
          document.querySelectorAll(".collection-sort-select").forEach((select) => {
            select.value = currentSort || select.querySelector("option[selected]")?.value || select.options[0]?.value;
          });
          this.updateSortSelectLabels(document);
        })
        .finally(() => {
          if (this.sectionRequest === request) {
            if (searchLoadMore) searchLoadMore.filterPending = false;
            this.toggleLoading(document.body, false);
          }
        });
    },

    toggleLoading: function (event, loading) {
      if (event) {
        clearTimeout(this.loadingCleanupTimeout);
        if (loading) {
          event.classList.remove("finish");
          event.classList.add("start", "loading");
        } else {
          event.classList.add("finish");
          this.loadingCleanupTimeout = setTimeout(function () {
            event.classList.remove("start", "loading", "finish");
          }, 500);
        }
      }
    },

    updateUrl: function (url, searchParams = false, historyUrl = null) {
      if (historyUrl !== null) {
        window.history.pushState({ url: historyUrl }, "", historyUrl);
        return;
      }

      if (searchParams) {
        const urlUpdate = `${window.location.pathname}?${searchParams}`;
        window.history.pushState({ url: urlUpdate }, "", urlUpdate);
      } else {
        window.history.pushState({ url: url }, "", url);
      }
    },
  };
})();
eventCollectionShopify.init();
